// Utils
import useDateLimits from '@/utils/hooks/datepicker/useDateLimits';
import { DATETIME_FORMAT_SCHEMAS } from '@/utils/hooks/format/useFormatDateTime';
import useUser from '@/utils/hooks/swr/useUser';

// Utils
import { useDatepickerGlobalStore } from '@/utils/zustand/providers/datepicker-global-provider';

// Lib
import { dayOfWeekNumber } from '@/lib/date/dayOfWeek';
import { datepickerGlobalPeriods } from '@/lib/periods';

// Components
import {
    DatepickerCalendar,
    DatepickerCompareTo,
    DatepickerFooter,
    DatepickerPanel,
    DatepickerPeriods,
    DatepickerPopover,
    DatepickerWrapper
} from '@/components/base/Datepicker/DatepickerComponent';
import { RecapDatepicker } from '@/components/layouts/LayoutPlatform/components/Header/components/DatepickerGlobal/RecapDatepicker';

export function DatepickerGlobal() {
    const { user } = useUser();
    const { getMaxDate, getMinDate } = useDateLimits();
    const { date, period, compareTo, updateDatepickerDate, updateDatepickerCompareTo } =
        useDatepickerGlobalStore((state) => state);

    const minDate = getMinDate();
    const maxDate = getMaxDate();

    const settings = {
        timezone: user.settings.timezone,
        dateFormat: DATETIME_FORMAT_SCHEMAS[user.settings.date_format],
        lang: user.settings.platform_language,
        minDate,
        maxDate
    };

    const datepickerDate = date?.from && date?.to ? date : { from: new Date(), to: new Date() };

    return (
        <DatepickerWrapper
            date={datepickerDate}
            period={period ?? 'last_30_days'}
            mode="range"
            onChange={updateDatepickerDate}
            settings={settings}
            dayPickerOptions={{
                weekStartsOn: dayOfWeekNumber[user.settings.first_day_week]
            }}>
            <DatepickerPopover
                popperOptions={{
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: ['auto']
                            }
                        }
                    ]
                }}>
                {({ open, setReferenceElement, setPopperElement, styles, attributes }) => (
                    <>
                        <RecapDatepicker setReferenceElement={setReferenceElement} />
                        <DatepickerPanel
                            open={open}
                            styles={styles}
                            attributes={attributes}
                            setPopperElement={setPopperElement}>
                            <DatepickerCalendar displayDataRetentionBanner />
                            <DatepickerFooter>
                                <DatepickerPeriods periods={datepickerGlobalPeriods} />
                                <DatepickerCompareTo
                                    compareTo={compareTo ?? 'previous_period'}
                                    onChange={updateDatepickerCompareTo}
                                />
                            </DatepickerFooter>
                        </DatepickerPanel>
                    </>
                )}
            </DatepickerPopover>
        </DatepickerWrapper>
    );
}
